import { atom } from 'recoil'

export const initialTourAtom = atom({
  key: 'initialTourAtom',
  default: false,
})

export const initialTourCompletedAtom = atom({
  key: 'initialTourCompletedAtom',
  default: false,
})
